import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { useContent } from "../context/ContentContext";

export const Footer = () => {
  const { content } = useContent();
  const COMPANY = content.company;
  return (
    <footer data-testid="footer" className="bg-navy-deep text-paper grain relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 relative z-10">
        <div className="grid md:grid-cols-3 gap-12 md:gap-8">
          <div>
            <img src={COMPANY.logo} alt="Cancella Infissi" className="h-20 w-auto object-contain bg-paper/95 p-3 inline-block" />
            <p className="mt-6 text-paper/50 text-sm leading-relaxed max-w-xs">
              {COMPANY.tagline}. Artigianalità italiana a Scorrano, nel cuore del Salento.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={COMPANY.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-10 h-10 flex items-center justify-center border border-paper/20 text-paper/80 hover:bg-gold hover:border-gold hover:text-navy transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
              <a
                href={COMPANY.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center border border-paper/20 text-paper/80 hover:bg-gold hover:border-gold hover:text-navy transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div>
            <p className="eyebrow mb-5">Contatti</p>
            <ul className="space-y-4 text-paper/70 text-sm">
              <li className="flex items-center gap-3"><Phone size={16} className="text-gold" /> <a href={`tel:${COMPANY.phoneHref}`} className="hover:text-gold transition-colors">{COMPANY.phone}</a></li>
              <li className="flex items-center gap-3"><Mail size={16} className="text-gold" /> <a href={`mailto:${COMPANY.email}`} className="hover:text-gold transition-colors">{COMPANY.email}</a></li>
              <li className="flex items-start gap-3"><MapPin size={16} className="text-gold mt-0.5" /> {COMPANY.address}</li>
              <li className="flex items-center gap-3"><Facebook size={16} className="text-gold" /> <a href={COMPANY.facebook} target="_blank" rel="noreferrer" className="hover:text-gold transition-colors">cancella.infissi</a></li>
              <li className="flex items-center gap-3"><Instagram size={16} className="text-gold" /> <a href={COMPANY.instagram} target="_blank" rel="noreferrer" className="hover:text-gold transition-colors">cancellainfissi</a></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-5">Orari di apertura</p>
            <ul className="space-y-3 text-paper/70 text-sm">
              {COMPANY.hours.map((h) => (
                <li key={h.d} className="flex justify-between border-b border-paper/10 pb-2">
                  <span>{h.d}</span>
                  <span className="text-paper/90">{h.h}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-paper/10 flex flex-col sm:flex-row justify-between items-center gap-4 text-[0.7rem] text-paper/40 uppercase tracking-[0.15em]">
          <p>© {new Date().getFullYear()} Cancella Infissi — P. IVA {COMPANY.piva}</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-gold transition-colors">Privacy</Link>
            <Link to="/cookie" data-testid="footer-cookie-link" className="hover:text-gold transition-colors">Cookie</Link>
            <span className="hidden sm:inline">Scorrano (LE) · Italia</span>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-[0.72rem] text-paper/40">
          <span>Sito creato da</span>
          <a
            href="https://odyneai.com"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-odyneai"
            className="inline-flex items-center gap-1.5 text-paper/75 hover:text-gold transition-colors"
          >
            <img src="/odyneai-logo.png" alt="OdyneAI" className="h-5 w-5 object-contain" />
            <span className="font-semibold tracking-wide">OdyneAI</span>
          </a>
        </div>
      </div>
    </footer>
  );
};
